import type { ScreenKey } from './screens';

export type PrimaryTab = 'home' | 'explore' | 'host' | 'trip' | 'my';

/** Focused flows own their bottom composer/step actions. All other screens keep navigation. */
const FOCUSED_SCREENS = new Set<ScreenKey>([
  'welcome',
  'auth',
  'diagnosis',
  'chatRoom',
  'plans',
  'checkout',
]);

const SCREEN_TABS: Partial<Record<ScreenKey, PrimaryTab>> = {
  home: 'home',
  search: 'home',
  questions: 'home',
  questionDetail: 'home',
  journeys: 'home',
  journeyDetail: 'home',
  trends: 'home',
  trendDetail: 'home',
  explore: 'explore',
  exploreMap: 'explore',
  experienceDetail: 'explore',
  treatmentDetail: 'explore',
  clinicDetail: 'explore',
  chat: 'host',
  diagnosisResult: 'host',
  trip: 'trip',
  itinerary: 'trip',
  planner: 'trip',
  bookings: 'trip',
  bookingDetail: 'trip',
  bookingReview: 'trip',
  travelInfo: 'trip',
  aftercareList: 'trip',
  aftercare: 'trip',
  my: 'my',
  saved: 'my',
  recent: 'my',
  settings: 'my',
  membership: 'my',
  products: 'my',
  productDetail: 'my',
  points: 'my',
  coupons: 'my',
  reviews: 'my',
  payments: 'my',
  notifications: 'my',
  checkoutComplete: 'my',
  help: 'my',
  legal: 'my',
};

export function screenNavigation(screen: ScreenKey | undefined) {
  return {
    visible: !screen || !FOCUSED_SCREENS.has(screen),
    tab: screen ? SCREEN_TABS[screen] : undefined,
  };
}
